import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AuditExplorerPage } from "@/features/audit-explorer";
import {
  AUDIT_EVENT_TYPE_VALUES,
  AUDIT_INTEGRITY_VALUES,
  AUDIT_PHI_LEVEL_VALUES,
  AUDIT_TIME_RANGE_VALUES,
} from "@/features/audit-explorer/types";

const auditExplorerSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(20),
  q: z.string().optional().catch(undefined),
  eventType: z.enum(AUDIT_EVENT_TYPE_VALUES).optional().catch(undefined),
  actor: z.string().optional().catch(undefined),
  resourceType: z.string().optional().catch(undefined),
  action: z.string().optional().catch(undefined),
  policyVersion: z.string().optional().catch(undefined),
  modelVersion: z.string().optional().catch(undefined),
  integrity: z.enum(AUDIT_INTEGRITY_VALUES).optional().catch(undefined),
  phiLevel: z.enum(AUDIT_PHI_LEVEL_VALUES).optional().catch(undefined),
  environment: z.string().optional().catch(undefined),
  timeRange: z.enum(AUDIT_TIME_RANGE_VALUES).optional().catch(undefined),
});

export const Route = createFileRoute("/audit-explorer/")({
  validateSearch: auditExplorerSearchSchema,
  component: () => (
    <PermissionGuard module="audit_explorer">
      <AuditExplorerPage />
    </PermissionGuard>
  ),
});
